import submitCommand from '../../../services/submitCommand';
import cacheService from '../../../services/cacheService';

export const removeStepFromPathway = (pathwayId: string, entityId: string, initiatingUserId: string) => {
  cacheService.remove(`/v1/workflows/${pathwayId}`);

  return submitCommand(
    pathwayId,
    {
      id: pathwayId,
      entityId: entityId,
      initiatingUserId: initiatingUserId,
    },
    'RemoveStepFromWorkflow',
    'StepIsRemovedFromWorkflow',
    ['WorkflowError', 'WorkflowDeleted']
  );
};
